import { render, staticRenderFns } from "./WikiImportTakahiro.vue?vue&type=template&id=55d6e0fe"
import script from "./WikiImportTakahiro.vue?vue&type=script&lang=ts"
export * from "./WikiImportTakahiro.vue?vue&type=script&lang=ts"
import style0 from "./WikiImportTakahiro.vue?vue&type=style&index=0&id=55d6e0fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports